import React from "react"

type OnboardingTooltipProps = {
  open: boolean
  title: React.ReactNode
  placement?: "above-center" | "inside-top"
  containerClassName?: string
  positionClassName?: string
  tooltipClassName?: string
  children: React.ReactNode
  "data-testid"?: string
}

export type OnboardingTooltipConfig = Omit<OnboardingTooltipProps, "children">

export const OnboardingTooltip: React.FC<OnboardingTooltipProps> = ({
  open,
  title,
  placement = "above-center",
  containerClassName,
  positionClassName,
  tooltipClassName,
  children,
  "data-testid": dataTestid,
}) => {
  const overlayPositionClassName =
    placement === "inside-top"
      ? `left-1/2 top-4 -translate-x-1/2 ${positionClassName ?? ""}`.trim()
      : `bottom-full left-1/2 mb-3 -translate-x-1/2 ${positionClassName ?? ""}`.trim()

  return (
    <div className={`relative ${containerClassName ?? ""}`.trim()}>
      {children}
      {open ? (
        <div className={`pointer-events-none absolute z-20 ${overlayPositionClassName}`} data-testid={dataTestid}>
          <div
            className={`relative max-w-[280px] rounded-[14px] bg-[#171717] px-4 py-3 text-center text-[14px] font-medium leading-[1.35] text-white shadow-[0_8px_24px_rgba(15,23,42,0.2)] ${tooltipClassName ?? ""}`.trim()}
          >
            {title}
            <div className="absolute left-1/2 top-full h-0 w-0 -translate-x-1/2 border-x-[10px] border-x-transparent border-t-[10px] border-t-[#171717]" />
          </div>
        </div>
      ) : null}
    </div>
  )
}
